import React from 'react';
import { styled } from '@material-ui/core/styles';
import { DSTheme } from '../../styles/themes/types';

import './Button.scss';

export interface ButtonProps {
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  text: string;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
}

const Button: React.FC<ButtonProps> = ({ onClick, text, className, type }) => (
  <button onClick={onClick} className={className || ''} type={type}>
    {text}
  </button>
);

// 'styled' implicitly converts props into string, so we convert 'special' prop into a string-boolean,
// instead of just using a simple boolean.
export const DSButton = styled('button')(
  ({ theme, special }: { theme: DSTheme; special?: 'true' | 'false' }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px 32px',
    height: '48px',
    backgroundColor:
      special === 'true' ? theme.palette.primary.contrastText : theme.palette.primary.main,
    color: special === 'true' ? theme.palette.primary.main : theme.palette.primary.contrastText,
    borderRadius: '16px',
    border: 0,
    cursor: 'pointer',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '14px',
    lineHeight: '24px',
    minWidth: '140px',
    width: 'fit-content',

    [theme.breakpoints.up('md')]: {
      height: '56px',
      padding: '12px 0',
    },

    '&.wide': {
      width: '100%',
    },

    '&.disabled, &:disabled': {
      backgroundColor: 'inherit',
      border: '1px solid',
      borderColor: theme.palette.text.disabled,
    },

    '&.disabled-opacity': {
      opacity: '0.5',
    },
  }),
);

export default Button;
